/* eslint-disable */
import dataStorage from '@/common/contact-selector/utils/dataStorage';
import getTypeof from '@/common/contact-selector/utils/getTypeof';

const KFUIN_STORE_KEY = 'QD_KFUIN';
const NORUIN_STORE_KEY = 'QD_NORUIN';
const UIN_RANGE_KEY = 'QD_UIN_RANGE';
const GROUP_KEY = 'groupList';

localStorage.setItem(KFUIN_STORE_KEY, '');
localStorage.setItem(NORUIN_STORE_KEY, '');
localStorage.setItem(UIN_RANGE_KEY, '');
/**
 * 查找list中的主号并对其type做相应的设置
 * @param {Array} list
 */
function setKfuinTypeInList(list) {
    let newList = [];
    const uins = _pickUinsFromList(list);

    return new Promise((resolve, reject) => {
        filterKfuin(uins)
            .then(uinMaps => {
                newList = _setListAttributeByIds({
                    originalList: list,
                    operateIdMaps: uinMaps,
                    attribute: 'type'
                });
                resolve(newList);
            })
            .catch(err => {
                reject(err);
            });
    });
}

/**
 * 过滤出主号号码
 * @param {Array} uins
 */
function filterKfuin(uins) {
    const kfuinMap =
        dataStorage.readData({
            key: KFUIN_STORE_KEY,
            type: 'json'
        }) || {};

    const noruinMap =
        dataStorage.readData({
            key: NORUIN_STORE_KEY,
            type: 'json'
        }) || {};

    const uinRangeInfo =
        dataStorage.readData({
            key: UIN_RANGE_KEY,
            type: 'json'
        }) || {};

    let couldBeKfuin = [];

    return new Promise((resolve, reject) => {
        // 获取号段
        _getUinRange(uinRangeInfo, uins)
            .then(uinRange => {
                // 通过号段过滤备选uin
                uinRangeInfo.uinRange = uinRange;
                couldBeKfuin = searchUinByUinRange(uins, uinRange);
                const tempList = [];
                // 比对现有存储，缩小需要请求的号码范围
                for (let i = 0, len = couldBeKfuin.length; i < len; i++) {
                    const uin = couldBeKfuin[i];
                    if (kfuinMap[uin] || noruinMap[uin]) continue;
                    tempList.push(uin);
                }
                couldBeKfuin = tempList;
                // 通过php对号码做最后的验证
                if (couldBeKfuin && couldBeKfuin.length) {
                    return _checkUpUin(couldBeKfuin);
                }
                resolve(kfuinMap);
                return null;
            })
            .then(uinMaps => {
                if (!uinMaps) return null;
                for (let i = 0, len = couldBeKfuin.length; i < len; i++) {
                    const uin = couldBeKfuin[i];
                    noruinMap[uin] = uinMaps[uin];
                }

                for (const uin in uinMaps) {
                    if (uinMaps.hasOwnProperty(uin)) {
                        kfuinMap[uin] = uinMaps[uin];
                        delete noruinMap[uin];
                    }
                }
                _updateAboutKfuinStorage({
                    kfuinMap,
                    noruinMap,
                    uinRange: uinRangeInfo.uinRange
                });
                resolve(uinMaps);
            })
            .catch(err => {
                reject(err);
            });
    });
}

/**
 * 根据号段过滤Uin
 * 这里可以考虑改为大数比较而不是用number比较
 * @param {String[]} uins
 * @param {Object[]} uinRange
 */
function searchUinByUinRange(uins, uinRange) {
    const newUins = [];
    const reg = {
        3: new RegExp(/^\d{3}/),
        4: new RegExp(/^\d{4}/),
        5: new RegExp(/^\d{5}/),
        6: new RegExp(/^\d{6}/),
        7: new RegExp(/^\d{7}/),
        8: new RegExp(/^\d{8}/),
        9: new RegExp(/^\d{9}/),
        10: new RegExp(/^\d{10}/),
        11: new RegExp(/^\d{11}/),
        12: new RegExp(/^\d{12}/),
        13: new RegExp(/^\d{13}/),
        14: new RegExp(/^\d{14}/)
    };
    const uinRangeLength = uinRange.length;

    for (let uinIndex = 0, uinLength = uins.length; uinIndex < uinLength; uinIndex++) {
        const uin = uins[uinIndex];
        const tempNumber = parseInt('00000000000000'.replace(reg[uin.toString().length], uin));

        for (let uinRangeIndex = 0; uinRangeIndex < uinRangeLength; uinRangeIndex++) {
            const uinRangeItem = uinRange[uinRangeIndex];
            const numberLength = uinRangeItem.from.toString().length;
            const from = parseInt('00000000000000'.replace(reg[numberLength], uinRangeItem.from));
            const to = parseInt('00000000000000'.replace(reg[numberLength], uinRangeItem.to));
            if (tempNumber >= from && tempNumber <= to) {
                newUins.push(uin);
                break;
            }
        }
    }
    return newUins;
}

/**
 * 过滤掉uins中的主号
 * @param {String[]} uins
 * @param {String[]} kfuin
 */
function filterUinByKfuin(uins, kfuins) {
    const newUins = [];
    const kfuinLength = kfuins.length;

    for (let uinIndex = 0, uinLength = uins.length; uinIndex < uinLength; uinIndex++) {
        const uin = uins[uinIndex];
        let flag = true;
        for (let kfuinIndex = 0; kfuinIndex < kfuinLength; kfuinIndex++) {
            const kfuin = kfuins[kfuinIndex];
            if (kfuin == uin) {
                flag = false;
                break;
            }
        }
        if (flag) {
            newUins.push(uin);
        }
    }
    return newUins;
}

/**
 * 获取主号相关号段
 * @param {Object} uinRangeInfo 内存中继承的号段
 * @param {Array} uins
 */
function _getUinRange(uinRangeInfo, uins) {
    return new Promise((resolve, reject) => {
        if (
            !uinRangeInfo ||
            !uinRangeInfo.uinRange ||
            (uinRangeInfo.expire && new Date().getTime() - uinRangeInfo.expire > 86400000)
        ) {
            Vue.prototype.$_sAjax
                .post(
                    '/hb/selector/getNumberRange',
                    {
                        uins,
                        filter: [4]
                    },
                    {
                        dataType: 'json',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(res => {
                    if (window.parseInt(res.code) === 0) {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                })
                .catch(err => {
                    reject(err);
                });
        } else {
            resolve(uinRangeInfo.uinRange);
        }
    });
}

/**
 * 获取uin的类型
 * @param {Object} uinMaps
 */
function _checkUpUin(uins) {
    return new Promise((resolve, reject) => {
        Vue.prototype.$_sAjax
            .post(
                '/hb/selector/uinType',
                {
                    uins,
                    filter: [1, 3, 4, 7]
                },
                {
                    dataType: 'json',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(res => {
                if (window.parseInt(res.code) === 0) {
                    const uinMaps = {};
                    res.data.forEach(item => {
                        let type;
                        if (item.type == 1 || item.type == 3 || item.type == 7) {
                            type = 4;
                        } else if (item.type == 4) {
                            if (item.subType == 1) {
                                type = 2;
                            } else if (item.subType == 2) {
                                type = 3;
                            }
                        }
                        uinMaps[item.uin] = {
                            uin: item.uin,
                            type
                        };
                    });
                    resolve(uinMaps);
                } else {
                    reject(res);
                }
            });
    });
}

/**
 * 更新缓存关于主号的数据
 * @param {Object} params
 */
function _updateAboutKfuinStorage(params) {
    const {
        noruinMap, // 普通号码Map
        kfuinMap, // 主号Map
        uinRange // 主号可能的号段
    } = params;

    dataStorage.writeData({
        key: KFUIN_STORE_KEY,
        data: kfuinMap
    });

    dataStorage.writeData({
        key: NORUIN_STORE_KEY,
        data: noruinMap
    });

    dataStorage.writeData({
        key: UIN_RANGE_KEY,
        data: {
            expire: new Date().getTime(),
            uinRange
        }
    });
}

/**
 * 从数据源list中取出uin数组
 * @param {Array} list
 */
function _pickUinsFromList(list) {
    let newList = [];
    list.forEach(baseItem => {
        const listItem = baseItem[[GROUP_KEY]] || [];
        if (baseItem.type === 'group' || (getTypeof(listItem) === 'array' && listItem.length)) {
            newList = newList.concat(_pickUinsFromList(listItem));
        } else {
            newList.push(baseItem.id);
        }
    });
    return newList;
}

/**
 * 将originalList中id在operateIdMaps中的元素设置字段为attribute的值为value
 * @param {Object} params
 */

function _setListAttributeByIds(params) {
    const { originalList, operateIdMaps, attribute, value } = params;
    originalList.forEach((baseItem, index) => {
        const listItem = baseItem[GROUP_KEY] || [];
        if (baseItem.type === 'group' || (getTypeof(listItem) === 'array' && listItem.length)) {
            baseItem[GROUP_KEY] = _setListAttributeByIds({
                originalList: listItem,
                operateIdMaps,
                attribute,
                value
            });
        } else if (operateIdMaps[baseItem.id]) {
            originalList[index][attribute] = operateIdMaps[baseItem.id][attribute];
        }
    });
    return originalList;
}

/**
 * @description 过滤关闭“允许群成员发起临时会话”的这部分群 @feiyugao
 * 仅pc有该需求，移动端不会限制 产品 @rachelxia pc开发 @jiayongzuo
 * @param  {} originList
 */
function filterAllowCreateGroup(originList, troopLevel) {
    const list = originList || [];
    return list.filter(listItem => {
        let allowCreateTroop = true;
        if (listItem.config && listItem.config.dwGroupFlagEx2) {
            /* eslint-disable no-bitwise */
            allowCreateTroop = listItem.config.dwGroupFlagEx2 >> 0x8000 !== 0x8000;
        }
        return allowCreateTroop;
    });
}


// 过滤隐私群和同事群
function filterPrivacyTroop(originList, troopLevel) {
    let list = originList;
    if(troopLevel === 'group') {
        list = [{
            groupList: list
        }];
    }
    let newList = [];
    for (let groupIndex = 0, groupLength = list.length; groupIndex < groupLength; groupIndex += 1) {
        const newGroupItem = { ...list[groupIndex] };
        const newGroupList = [];
        for (let itemIndex = 0, itemLength = newGroupItem.groupList.length; itemIndex < itemLength; itemIndex += 1) {
            const item = newGroupItem.groupList[itemIndex] || {};
            if (!(`${item.isColleague}` === '1' || `${item.isPrivacy}` === '1')) {
                newGroupList.push(item);
            }
        }
        newGroupItem.groupList = newGroupList;
        if (troopLevel === 'group') {
            newList = newGroupItem.groupList;
        }else{
            if (newGroupList.length > 0) {
                newList.push(newGroupItem);
            }

        }
    }
    return newList;
}

/**
 * @description 群和讨论组的统一过滤
 * @param  {Array} list 原列表
 * @param  {object} config 相关配置，主要是取过滤方式
 * @param  {String} troopLevel 群在列表里面的级别,用来区分群成员中的群元素和群中的群元素,'group': 组, 'unit': 元素
 */
function filterTroopList(list, config, troopLevel) {
    let newList = list || [];
    let filter = config.filter;
    // 增加健壮性，统一过滤内容的数据类型为字符串
    if (getTypeof(filter) === 'array') {
        filter = filter.map(filterItem => {
            return filterItem + ''
        });
    }
    if (typeof filter === 'string' || typeof filter === 'number') {
        filter = [filter + ''];
    }

    filter = new Set(filter);

    if (config.filter) {
        // 过滤不允许群成员发起临时会话的群，这里后面可能是数组
        if (filter.has('2')) {
            newList = filterAllowCreateGroup(list, troopLevel);
        }
        // 隐藏私有群
        if (filter.has('troopMemberPrivacyHide') || filter.has('1')) {
            newList = filterPrivacyTroop(list, troopLevel);
        }
    }
    return newList;
}

export default {
    filterTroopList,
    filterKfuin,
    setKfuinTypeInList,
    searchUinByUinRange,
    filterAllowCreateGroup
};
